import { useMemo } from 'react'

export function useIsItemAttributionScoped(itemScope, scope) {
  const scoped = useMemo(() => {
    // if no item or empty scope
    if (!itemScope || !scope?.length) {
      return true
    }

    // if item scope is in the given scope set
    return scope.includes(itemScope)
  }, [scope, itemScope])

  return scoped
}
